import { Component, Inject, OnInit, Optional } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';

@Component({
    selector: 'tt-travel-bill-log',
    templateUrl: './travel-bill-log.component.html',
    styleUrls: ['./travel-bill-log.component.css'],
    standalone: false,
})
export class TravelBillLogComponent implements OnInit {
    public params?: { travelbillog_keyno: string };

    public page?: TravelBillLogGet;

    constructor(
        private datatask: DataTaskService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    private async loadPage() {
        if (!!this.params) {
            this.page = (await this.datatask.Post(1722, this.params))[0];
        }
    }

    private async init() {
        this.loadPage();
    }

    ngOnInit() {
        this.init();
    }
}

interface TravelBillLogGet {
    reg_datetime: string;
    reg_by_portal_user_name: string;
    note: string;
}
